__turbopack_context__.v({
  "testimonial_card": "TestimonialCard-module-scss-module__Mivd-a__testimonial_card",
});
